<span>
    {{linkSetting?.before_text}}
    <button voxelButtonAction (click)="onOpenModalCR()">{{linkSetting?.link_text}}</button>
    {{linkSetting?.after_text}}
</span>


<button #solicitationSteps="voxelOverlayOrigin" voxelOverlayOrigin class="no-visible"></button>

<voxel-modal id="dialog-a" modalAriaLabelledby="types-modal-title" [modalOrigin]="solicitationSteps"
    [modalIsOpen]="chkDisable" *ngIf="CONTENT_BOUNDS" (modalClose)="onCloseModalCR($event)">
    <h3 [textContent]="CONTENT_BOUNDS.modals.title" class="voxel-pv-3"></h3>
    <p [textContent]="CONTENT_BOUNDS.modals.description" class="voxel-text-section-02 voxel-pb-7"></p>
     <div class="voxel-modal__content_search" [formGroup]="form">
        <voxel-list>
          <li voxelListSimple *ngFor="let slSt of stepsInformation">
            <div class="voxel-row voxel-border-color-soft" style="display:flex;">
              <div class="voxel-col-1">
                <voxel-icon  type="primary" class="voxel-col-1">{{slSt.icon}}</voxel-icon>
              </div>
              <div class="voxel-col-11" style="text-align-last:left;">
                <voxel-list-text [textContent]="slSt.caption" class="voxel-text-section-02 voxel-col-12"></voxel-list-text>
                <voxel-list-descr [textContent]="slSt.description" class="voxel-text-overline voxel-col-12" style="text-align: justify;flex: revert;overflow: hidden;" ></voxel-list-descr>
              </div>
            </div>
          </li>
        </voxel-list>
        <div class="voxel-row voxel-pv-6" *ngIf="showCheckDisplayModal">
          <voxel-form-selection class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-12" >
              <input type="checkbox" formControlName="chkstepsmodal" voxelCheckbox (change)="modalVisible()"/>
              <span [textContent]="CONTENT_BOUNDS.modals.chk_caption" class="voxel-col-sm-3 voxel-col-md-8 voxel-text-section-02"></span>
          </voxel-form-selection>
        </div>
        <div class="voxel-row voxel-pv-6" *ngIf="visibleFiducialText">
          <span [textContent]="CONTENT_BOUNDS.modals.fiducialStepText" style="font-size: 16px;" class="voxel-col-12"></span>
        </div>
    </div>
    <div voxelModalFooter>
      <div class="voxel-row-4" style="align-content: baseline">
        <div class="voxel-col-1"></div>
        <button voxelButton (click)="onCloseModalCR($event)" [textContent]="CONTENT_BOUNDS.modals.button_caption" class="voxel-col-2"></button>
      </div>
    </div>

</voxel-modal>